export const searchByList = [
    { id: 1, description: 'Ticket #' },
    { id: 2, description: 'Email' },
    { id: 3, description: 'Name' },
    { id: 4, description: 'Subject/Message' },
];

export enum SearchBy {
    TicketNumber = 1,
    Email = 2,
    Name = 3,
    SubjectMessage = 4
}